// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_ItemsWithBothLaudosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /so/orders/items_with_both_laudos
 *
 * List of service items with both entry and exit reports confirmed.
 */
import type { Orders_BothLaudosItemRow } from './Orders_BothLaudosItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_ItemsWithBothLaudosResponseDados {
items: Orders_BothLaudosItemRow[]
total: number
}

export type Orders_ItemsWithBothLaudosResponse = ApiResponse<Orders_ItemsWithBothLaudosResponseDados>;

registerResponseContract('Orders_ItemsWithBothLaudosResponse', {
  items: {
    type: 'array',
    required: true,
    items: {
      so_order_item_id:          { type: 'number',  required: true },
      so_order_id:               { type: 'number',  required: true },
      so_order_status:           { type: 'string',  required: true },
      so_order_created_at:       { type: 'string',  required: false },
      so_order_franchise_id:     { type: 'number',  required: true },
      franchise_name:            { type: 'string',  required: false },
      so_order_client_id:        { type: 'number',  required: false },
      so_order_client_name:      { type: 'string',  required: false },
      so_order_item_qrcode:      { type: 'string',  required: false },
      so_service_name:           { type: 'string',  required: false },
      so_service_category_name:  { type: 'string',  required: false },
      so_priority_name:          { type: 'string',  required: false },
      so_order_item_description: { type: 'string',  required: false },
      entry_report_id:           { type: 'number',  required: true },
      entry_report_confirmed_at: { type: 'string',  required: false },
      exit_report_id:            { type: 'number',  required: true },
      exit_report_confirmed_at:  { type: 'string',  required: false },
      total_attribute_count:     { type: 'number',  required: true },
      photo_attribute_count:     { type: 'number',  required: true },
      requests_total:            { type: 'number',  required: true },
      requests_verified:         { type: 'number',  required: true },
      entry_report_photo:        { type: 'string',  required: false },
      exit_report_photo:         { type: 'string',  required: false },
    },
  },
  total: { type: 'number',  required: true },
})
